@if (showNameSuggestion()) {
  <vdw-ellipsis-label [text]="'GENERAL.SUGGESTION' | bmsTranslate: {value: nameSuggestion() ?? ''}" matTooltipPosition="above" />
  <a class="url" (click)="applySuggestion.emit(nameSuggestion())">{{ 'GENERAL.ACTIONS.APPLY' | bmsTranslate }}</a>
}
